import exologAdmin from './exologAdmin'
export default exologAdmin